import { parse as parseUrl } from 'url';
import Debug from 'debug';

import 'next';

const debug = Debug('rs:store/middleware/api/fetch');

class Fetch {
  static getPathName = (url) => parseUrl(url).pathname;

  async fetch(url, options) {
    debug('fetch', url);

    return fetch(url, options);
  }
}

export default Fetch;
